export const SPECTATOR_API = '/api/spectator/matches';
//# sourceMappingURL=spectator.js.map